import { jsxs as o, jsx as i } from "react/jsx-runtime";
import { c as t } from "../../../clsx-OuTLNxxd.js";
const a = "_loader_dgjq8_29", l = "_circle_dgjq8_41", e = {
  loader: a,
  "is-small": "_is-small_dgjq8_29",
  "is-medium": "_is-medium_dgjq8_33",
  "is-large": "_is-large_dgjq8_37",
  circle: l,
  "moving-element": "_moving-element_dgjq8_44",
  "on-dark": "_on-dark_dgjq8_47",
  "dialog-overlay-show": "_dialog-overlay-show_dgjq8_1",
  "dialog-content-show": "_dialog-content-show_dgjq8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dgjq8_1"
}, d = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
function m({ onDark: s, size: r = "medium" }) {
  return /* @__PURE__ */ o(
    "svg",
    {
      className: t(e.loader, e[d[r]], s && e["on-dark"]),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ i("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ i("circle", { className: e.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ o(
          "circle",
          {
            className: e["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ i("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ i(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
export {
  m as Loader
};
